import * as React from "react";
const SvgPaperPlane = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 1H5L16 7V9L5 15H2L3 9H8V7H3L2 1Z", fill: "currentColor" }));
export default SvgPaperPlane;
